var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1339_3220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1339_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91248 13.6505L11.7937 9.00049H8.79373L9.33748 4.74424L5.86873 9.75049H8.47498L7.91248 13.6505ZM6.74998 11.2505H4.42498C4.12498 11.2505 3.9031 11.1161 3.75935 10.8474C3.6156 10.5786 3.63123 10.3192 3.80623 10.0692L9.41248 2.00674C9.53748 1.83174 9.69998 1.70987 9.89998 1.64112C10.1 1.57237 10.3062 1.57549 10.5187 1.65049C10.7312 1.72549 10.8875 1.85674 10.9875 2.04424C11.0875 2.23174 11.125 2.43174 11.1 2.64424L10.5 7.50049H13.4062C13.7312 7.50049 13.9594 7.64424 14.0906 7.93174C14.2219 8.21924 14.1812 8.48799 13.9687 8.73799L7.79998 16.1255C7.66248 16.288 7.49373 16.3942 7.29373 16.4442C7.09373 16.4942 6.89998 16.4755 6.71248 16.388C6.52498 16.3005 6.3781 16.1661 6.27185 15.9849C6.1656 15.8036 6.12498 15.6067 6.14998 15.3942L6.74998 11.2505Z",
    fill: "#6F0D0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/Flash.b6c4852e3e85e6d1c2a42eb2bd4a1c32.svg";
export { ForwardRef as ReactComponent };